import React from 'react';
import { Bot, User as UserIcon } from 'lucide-react';
import ChatQuickReplies from './ChatQuickReplies';

/**
 * Individual chat message bubble component
 */
const ChatMessageBubble = ({ 
  message, 
  onQuickReply, 
  onCategorySelect, 
  onSubCategorySelect, 
  onReviewAction 
}) => {
  const { role, content, timestamp, quickReplies } = message;
  const isAssistant = role === 'assistant';

  // Parse bold text (**text**)
  const formatContent = (text) => {
    return text.split('**').map((part, i) =>
      i % 2 === 0 ? part : <strong key={i}>{part}</strong>
    );
  };

  return (
    <div
      className={`flex gap-3 ${
        isAssistant ? 'flex-row' : 'flex-row-reverse'
      } animate-in fade-in slide-in-from-bottom-4 duration-500`}
    >
      {/* Avatar */}
      <div className={`w-10 h-10 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg ${
        isAssistant
          ? 'bg-gradient-to-br from-indigo-500 to-blue-500'
          : 'bg-gradient-to-br from-gray-700 to-gray-900'
      }`}>
        {isAssistant ? (
          <Bot className="w-6 h-6 text-white" />
        ) : (
          <UserIcon className="w-6 h-6 text-white" />
        )}
      </div>

      {/* Message Content */}
      <div className={`max-w-[75%] ${isAssistant ? 'items-start' : 'items-end'}`}>
        {/* Message Bubble */}
        <div
          className={`rounded-3xl px-6 py-4 shadow-lg ${
            isAssistant
              ? 'bg-white border-2 border-gray-100 text-gray-900'
              : 'bg-gradient-to-br from-gray-800 to-gray-900 text-white'
          }`}
        >
          <p className="text-sm leading-relaxed whitespace-pre-wrap">
            {formatContent(content)}
          </p>
        </div>

        {/* Quick Replies */}
        {quickReplies && (
          <ChatQuickReplies
            replies={quickReplies}
            onQuickReply={onQuickReply}
            onCategorySelect={onCategorySelect}
            onSubCategorySelect={onSubCategorySelect}
            onReviewAction={onReviewAction}
          />
        )}

        {/* Timestamp */}
        <p className="text-xs text-gray-500 mt-2 px-2">
          {new Date(timestamp).toLocaleTimeString('no-NO', {
            hour: '2-digit',
            minute: '2-digit'
          })}
        </p>
      </div>
    </div>
  );
};

export default ChatMessageBubble;
